<div *ngIf="showPrice">
  {{translate('consumer_total_price', 'Price: {0} {1}', price, currency)}}
</div>
<div *ngIf="!showPrice">
  {{translate('consumer_total_price_calculating', ' ', currency)}}
</div>
